import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledWrapper = styled(FlexBox)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    max-width: 800px;
    margin: 0 auto;
    text-align: center;

    & span {
        font-size: 24px;
        padding-bottom: 24px;

        ${media.md`
            font-size: 39px;
            line-height: 120%;
            padding-bottom: 46px;
        `}
    }
`;

export const StyledButtonsWrapper = styled(FlexBox)`
    justify-content: center;
    gap: 42px;

    ${media.md`
        gap: 56px;
    `}
`;

export const StyledText = styled.div`
    margin: 20px 0;
    font-size: 16px;
    font-family: ${({ theme }) => theme.fonts.title};
    color: ${({ theme }) => theme.colors.gs200};

    ${media.md`
        margin: 30px 0;
        font-size: 22px;
    `}
`;
